export const ensureTrailingSlash = (url) => {
    let href = url?.trim();
    if (!href) { return null; }
    return href?.endsWith('/') || href?.includes('#') || href?.includes('?') ? href : `${href}/`;
}